import {
  deviceEnquire,
  DEVICE_TYPE
} from '@/core/device';
import {
  mapState
} from 'vuex';

const AppDeviceEnquire = {
  mounted() {
    this._updateDevice();
    window.onresize = () => {
      this._updateDevice();
    };
  },
  methods: {
    _updateDevice() {
      const {
        $store
      } = this;
      deviceEnquire(deviceType => {
        switch (deviceType) {
          case DEVICE_TYPE.DESKTOP:
            $store.commit('TOGGLE_DEVICE', 'desktop');
            break
          case DEVICE_TYPE.TABLET:
            $store.commit('TOGGLE_DEVICE', 'tablet');
            break
          case DEVICE_TYPE.MOBILE:
          default:
            $store.commit('TOGGLE_DEVICE', 'mobile');
            break
        }
      });
    }
  }
};

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile() {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop() {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet() {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
};

export {
  AppDeviceEnquire,
  mixinDevice
};



// WEBPACK FOOTER //
// ./src/core/mixin.js